//libraries imports
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

//Core Components
import Loader from "../../../../core/common/loader";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../../router/all_routes";

// Other Components
import CreateReportComponent from "./components/CreateReport";

// Helpers

const CreateReport = () => {
  // STATE MANAGEMENT
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { reportType, upcomingReportType, allUsers, disableReportTypeChange } =
    location.state || {};

  // RENDER COMPONENT

  return (
    <>
      {isLoading && <Loader />}

      <div className="page-wrapper">
        <div className="content">
          {/* Header Section */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Create New Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Reports</li>
                  <li className="breadcrumb-item">Create</li>
                </ol>
              </nav>
            </div>

            {/* Show Create button only on main reports page */}
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="me-2 mb-2">
                <Link
                  to={all_routes.ersReportsOverview}
                  className="btn btn-primary d-inline-flex align-items-center fs-14">
                  <i className="ti ti-arrow-narrow-left me-1"></i>
                  Go Back
                </Link>
              </div>

              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* Content Area*/}
          <div className="reports-content" style={{ zIndex: 1 }}>
            <CreateReportComponent
              reportType={reportType}
              upcomingReportType={upcomingReportType}
              allUsers={allUsers}
              disableReportTypeChange={disableReportTypeChange}
            />
          </div>
        </div>

        {/* Footer Section */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default CreateReport;
